<template>
  <div class="user">
    <div class="photo">
      <img :src="getAvatar()" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span v-if="empleado != null">
          <label class="user-label-name">{{empleado.nombre}}</label>
          <b class="caret"></b>
        </span>
      </a>
      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <!-- <li>
                <a>
                  <span class="sidebar-mini">
                    <i class="fa fa-user-cog"></i>
                  </span>
                  <span class="sidebar-normal">Perfil Usuario</span>
                </a>
              </li>-->
              <li>
                <a @click="logout()">
                  <span class="sidebar-mini">
                    <md-icon>exit_to_app</md-icon>
                  </span>
                  <span class="sidebar-normal">Logout</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { userService, empleadoService } from "@/_services";

export default {
  components: {
    CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default: "CESAR BERROZPE",
    },
    avatar: {
      type: String,
      default: "/panel-reclamaciones/img/faces/cesar.jpg",
    },
  },
  data() {
    return {
      isClosed: true,
    };
  },
  computed: {
    empleado() {
      return this.$store.state.empleado.current;
    },
    user() {
      return this.$store.state.authentication.user;
    },
  },
  methods: {
    getAvatar() {
      return `https://florette-static-pro.azureedge.net/assets/empleados/${this.empleado.photo}`;
    },
    clicked: function (e) {
      e.preventDefault();
    },
    toggleMenu: function () {
      this.isClosed = !this.isClosed;
    },
    logout() {
      userService.logout();
      location.reload(true);
    },
  },
  mounted() {
    this.$store.dispatch("empleado/getInfo");
  },
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
.user-label-name {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
</style>
